import React from 'react';
import { Card, CardContent } from '@mui/material';
import { useTaskProcedureExecution } from './useTaskProcedureExecution';
import { ProcedureHeader } from './ProcedureHeader';
import { StartExecutionButton } from './StartExecutionButton';
import { ExecutionAccordion } from './ExecutionAccordion';
import { usePermissions } from '../../../../auth/hooks/usePermissions';

export default function TaskProcedureCard({ task, taskId, onExecutionUpdate, onProcedureCompleted, sx }) {
  const {
    expandedExecution,
    stepValues,
    submittingSteps,
    savedSteps,
    answeredSteps,
    procedureLoading,
    handleAccordionChange,
    handleStepValueChange,
    handleStartProcedureExecution,
    handleCompleteExecution,
  } = useTaskProcedureExecution({ task, taskId, onExecutionUpdate, onProcedureCompleted });
  // Running a procedure goes with working on the task (or procedure:execute)
  const { hasAnyScope } = usePermissions();
  const canStart = hasAnyScope(['procedure:execute', 'task:state:start']);
  const canAnswer = hasAnyScope(['procedure:execute', 'task:state:complete']);

  // Early return if no procedure
  if (!task?.procedure) {
    return null;
  }

  const { procedure } = task;
  const hasExecutions = procedure.executions && procedure.executions.length > 0;
  const execution = hasExecutions ? procedure.executions[0] : null;

  return (
    <Card sx={sx}>
      <CardContent>
        {/* Header with procedure info */}
        <ProcedureHeader procedure={procedure} />

        {/* Executions open with the task; the button is a fallback for older tasks */}
        {canStart && <StartExecutionButton
          onStartExecution={handleStartProcedureExecution}
          procedure={procedure}
          taskId={taskId}
          hasExecutions={hasExecutions}
        />}

        {/* Execution Accordion */}
        {hasExecutions && execution && (
          <ExecutionAccordion
            execution={execution}
            isExpanded={expandedExecution === execution.execution_id}
            stepValues={stepValues}
            submittingSteps={submittingSteps}
            savedSteps={savedSteps}
            answeredSteps={answeredSteps}
            procedureLoading={procedureLoading}
            procedureName={procedure.name}
            taskId={taskId}
            onAccordionChange={handleAccordionChange(execution.execution_id)}
            onStepValueChange={handleStepValueChange}
            onCompleteExecution={handleCompleteExecution}
            readOnly={!canAnswer}
          />
        )}
      </CardContent>
    </Card>
  );
}
